<template>
  <SupplierDashboard />
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import router from "@/router";
import { RouterPath } from "@/models/enum/routerPath";
import { useAuthenticationStore } from "@/stores/authentication";
import SupplierDashboard from "@/views/supplier-dashboard-view/SupplierDashboard.vue";
import { useSuppliersStore } from "@/stores/suppliersStore";
import { useSnackBarStore } from "@/stores/snackBarStore";

const authenticationStore = useAuthenticationStore();
const suppliersStore = useSuppliersStore();
const snackBarStore = useSnackBarStore();

onMounted(async () => {
  try {
    await suppliersStore.setSupplierList();
  } catch (error: any) {
    snackBarStore.showError(error.message);
  }
  if (authenticationStore.canAccessCustomerDashboard()) {
    router.push(RouterPath.Dashboard);
  }
});
</script>
